var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "59px",
    viewBox: "0 0 51 59",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Back") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Humanuculus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 0.195858829
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-16",
    transform: "translate(-63.000000, -94.000000)",
    fill: "#1E428A"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.6327218,94.3055121 L64.9409328,94 L111.737264,94 L113.110852,94.4015832 L114,94.8554953 L113.110852,119.815313 C112.676589,123.629101 112.218726,127.784763 111.737264,132.282298 C110.759768,139.033636 110.258574,145.939537 110.233681,153 L66.8659666,153 C66.7103574,144.827619 66.3674899,139.045046 65.8373638,135.65228 C64.9228812,129.210427 63.6327218,124.012639 63.6327218,119.815313 C63.6327218,112.202449 63.4218145,103.905185 63,94.92352 L63.6327218,94.3055121 Z",
    id: "Back"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/Back.ea19f3655eb493fd4ec539f7ac845983.svg";
export { ForwardRef as ReactComponent };